import {
  PAYMENT_METHOD_CASHIER_CHECK,
  PAYMENT_METHOD_ELECTRONIC_PAYMENT,
  PAYMENT_METHOD_MONEY_ORDER,
  PAYMENT_METHOD_PERSONAL_CHECK,
  PAYMENT_METHOD_OTHER,
} from 'common/financeConstants';

const rentPaymentOptionItems = [
  {
    label: 'Cashier’s Check',
    value: PAYMENT_METHOD_CASHIER_CHECK,
  },
  {
    label: 'Electronic Payment',
    value: PAYMENT_METHOD_ELECTRONIC_PAYMENT,
  },
  {
    label: 'Money Order',
    value: PAYMENT_METHOD_MONEY_ORDER,
  },
  {
    label: 'Personal Check',
    value: PAYMENT_METHOD_PERSONAL_CHECK,
  },
  {
    label: 'Other',
    value: PAYMENT_METHOD_OTHER,
  },
];

export default rentPaymentOptionItems;
